export default {
    index: {
        listagem_empresas: 'Company List',
        empresa_nao_encontrada: 'No companies found',
        criar_empresa: 'Create company',
        editar: 'Edit',
        nome: 'Name',
        apelido: 'Nickname',
        fornecedor: 'Provider'
    },
    form: {
        empresa_principal: 'Main Company',
        importar: 'Import',
        importar_vs: 'Import from Veus Saúde',
        importar_empresa_vs: 'Import company from Veus Saúde',
        informacoes: 'Information',
        nome: 'Name',
        nome_descricao: 'Company Name',
        mnemonico: 'Mnemonic',
        mnemonico_descricao: 'Company Mnemonic',
        id_solicitacao: 'Request ID',
        id_solicitacao_descricao: 'Company Request ID to RNDS',
        cnpj_empresa_descricao: 'Company CNPJ NUMBERS ONLY',
        cnes_empresa_descricao: 'Company CNES',
        veus_id_descricao: 'Company ID in Veus Saúde',
        pesquisar: 'Search',
        empresa_criada_sucesso: 'Company created successfully!',
        empresa_atualizada_sucesso: 'Company updated successfully!',
        provider: 'Provider',
        controle_qualidade: 'Quality Control',
        usuario: 'User',
        usuario_descricao: 'Company user in the quality control system.',
        senha: 'Password',
        senha_descricao: 'Company password in the quality control system.'
    }
}